export default __webpack_public_path__ + "static/media/glamorous.2186542e.svg";